import { lazy } from 'react';

import { PartnerViewExtensions } from '@ayocore/erp/crm/client/components/Partners/views/PartnerViewExtensions';

import { ACADEMY_ROLES } from '../../common/roles';
import { hasAnyAcademyRole } from '../guards';

const PartnerAcademyTab = lazy(() =>
  import('../components/PartnerAcademy/PartnerAcademyTab').then(m => ({
    default: m.PartnerAcademyTab,
  }))
);

/**
 * Снимок ролей без подписки: обработчик слота вызывается при рендере карточки
 * партнёра, React-хуки в нём использовать нельзя.
 *
 * ⚠️ Прячет вкладку, но не защищает операцию: активацию проверяет сервер —
 * `activateDealer` выдан через RBAC только `ACADEMY_ADMIN`.
 */
const canManageDealers = hasAnyAcademyRole(ACADEMY_ROLES.ACADEMY_ADMIN);

/**
 * Регистрирует вкладку «Академия» в карточке партнёра CRM: активация дилера
 * академии по телефону и его статус.
 *
 * Видна `ADMIN` и `ACADEMY_ADMIN`; остальным слот возвращает `null`, и вкладка
 * не появляется. Вызывается один раз из bootstrap.ts.
 */
export function registerAcademyPartnerViewExtensions(): void {
  PartnerViewExtensions.tabs.register(({ partner }) =>
    canManageDealers()
      ? {
          value: 'academy',
          label: 'Академия',
          content: <PartnerAcademyTab partnerId={partner.id} />,
        }
      : null
  );
}
